import { observable } from "mobx";

class Upload {
  @observable fileStatus: string = 'init';
  @observable parseStatus: string = 'init';
}

export default Upload;